import controller from './controller';
import template from './template.html';

const controllerAs = 'optionSelectSearchCtrl';
const bindings = {
  ngModel: '=',
  ngDirectiveId: '<',
  ngDisplayList: '=',
  ngCallback: '&',
  ngLabel: '<',
  ngHelpBlock: '<',
  ngRequired: '<',
  ngPlaceholder: '<',
  ngDisabled: '<',
  ngButtonLabel: '<',
  ngItemLabel: '<',
  ngTickProperty: '<',
  ngMaxLabels: '<',
  ngSelectionMode: '<'
};

export default {
  template,
  controller,
  controllerAs,
  bindings
};



// WEBPACK FOOTER //
// ./src/app/components/forms/optionSelectSearch/index.js